import React from 'react';
import PropTypes from 'prop-types';

import {
  QueueLabel,
  ScheduleQueueContainer,
  ScheduleQueueCard,
  ScheduleQueueTextArea,
} from './styles';
import texts from './texts.json';

const ScheduleQueue = ({ items, onTextChange }) => (
  <>
    <QueueLabel>{texts.label}</QueueLabel>
    <ScheduleQueueContainer>
      {items.map((item, index) => (
        <ScheduleQueueCard key={item.messageId}>
          <ScheduleQueueTextArea
            multiline
            fullWidth
            value={item.text}
            onChange={(e) => onTextChange(index, e.target.value)}
          />
        </ScheduleQueueCard>
      ))}
    </ScheduleQueueContainer>
  </>
);

ScheduleQueue.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    messageId: PropTypes.string.isRequired,
  })),
  onTextChange: PropTypes.func,
};

ScheduleQueue.defaultProps = {
  items: [],
  onTextChange: () => {},
};

export default ScheduleQueue;
